export default {
  en: {
    notFound: 'Page Not Found',
    back: 'Back Home',
    free: 'Free',
    next: 'Next',
    checkAll: 'Check all bundles',
    quick: 'Quick Links',
    reserve: 'Reserve a number',
    prices: 'Prices List',
    ourApps: 'Our Apps',
    navbar: {
      baseNavbar: ['Personal',
        'Business',
        'E-Payment',
        // 'Mtn Offers',
        'Mtn World'],
      serviceCenter: 'Service Centers',
      sectionNavbar: [
        'Home',
        'Products & Services',
        'Bundles',
        'MTN Offers',
        'Roaming'
      ],
      search: 'Search for offer, bundle or more',
      smallSearch: 'Search'
    },
    popularBundles: {
      title: 'The Most Popular Bundles',
      desc: 'Check All bundles',
      showResults: 'Showing Results For :',
      PrePaid: 'Pre Paid',
      PostPaid: 'Post Paid'
    },
    dailyBundles: {
      title: 'Daily Bundles',
      desc: 'Explore Our daily bundles including calls, sms & internet packages'
    },
    weeklyBundles: {
      title: 'Weekly Bundles',
      desc: 'Explore Our weekly bundles including calls, sms & internet packages'
    },
    monthlyBundles: {
      title: 'Monthly Bundles',
      desc: 'Explore Our monthly bundles including calls, sms & internet packages'
    },
    offersDesc: 'Discover the latest internet, minutes and SMS offers that you can activate on all new and existing MTN lines and get benefit from them monthly, weekly or daily ',
    mtnApps: {
      title: 'MTN Apps',
      desc: 'Stay Up To Date With All The MTN Apps'
    },
    specialServices: {
      title: 'Digital Services',
      desc: 'See All Of MTN Services'
    },
    featureController: {
      title: 'Feature Controller',
      desc: 'Explore Our Special Bundles For Post Paid Lines Including Calls, Sms & Internet Packages'
    },
    randomOffers: {
      title: 'Designed for you',
      desc: 'See All Of MTN Offers'
    },
    mtnApp: {
      title: 'Stay Up To Date!',
      desc: 'View and pay your bills, Recharge and balance transfers, Full access to and control of all numbers registered, Access to detailed call and data',
      git: 'Get the App for',
      download: 'Check the PWA for',
      downloadApp: 'Download iMTN App'
    },
    footer: {
      aboutMTN: 'About MTN',
      whoWeAre: 'Who We Are',
      financialReport: 'Financial Reports',
      pressCenter: 'Press Center',
      socialResponse: 'Social Responsibility',
      investorRelations: 'Investor Relations',
      partners: 'Partners',
      mtnCareers: 'MTN Careers',
      whyMtn: 'Why MTN',
      mtnJobs: 'MTN Jobs',
      emailHr: 'HR Team',
      mtnBundles: 'MTN Bundles',
      callsBundles: 'Calls Bundles',
      dataBundles: 'Data Bundles',
      smsBundles: 'SMS Bundles',
      mixBundles: 'MIX Bundles',
      downloadMtn: 'Download iMTN App',
      mtnApps: 'MTN Apps',
      myMtn: 'MTN',
      mtnTv: 'MTN TV',
      mtnRadio: 'MTN Radio',
      mtnCash: 'MTN Cash',
      terms: 'Terms & Conditions, Privacy Policy',
      copy: 'ALL RIGHTS RESERVED.',
      everyWhere: 'Every Where You Go'
    },
    readMore: 'Read More',
    needHelp: 'Support ?',
    swipe: 'Swipe',
    supportMenu: {
      faq: 'FAQs',
      serviceCenter: 'Service Centers',
      feedback: 'Feedback',
      contactUs: 'Contact Us'
    },
    welcomeMenu: {
      welcome: 'Welcome To MTN',
      login: 'Log in',
      register: 'Create Account',
      share: 'Share via Whatsapp',
      newCustomer: 'New Customer',
      deals: 'Register to reveal Exclusive Deals'
    },
    shareDialog: {
      title: 'Share this ',
      shareOffer: 'Sharer this offer',
      shareNews: 'Share this news',
      shareService: 'Share this service',
      shareItem: 'Share this item',
      shareBundle: 'Share this bundle',
      shareVia: 'Share Via',
      bundle: 'Bundle URL',
      offer: 'Offer URL',
      service: 'Service URL',
      social: 'Item URL',
      news: 'News URL',
      copy: 'Copy'
    },
    whoWeAre: {
      MainTitle: 'About MTN Syria',
      OurPartners: 'Our Partners',
      partnersDescription: ' Partnership Has Been Always The Best Way To Succeed In Different Domains, MTN Will Be Always Delighted To Be A Part Of Your Success',
      About: 'About',
      companyName: 'Company Name'
    },
    socialResponsibility: {
      title: 'Social Responsibility',
      desc: 'MTN Syria Is The Leading Provider In Telecommunications Services, Offering a Remarkable Cellular Network Access and Business Solutions'
    },
    pressCenter: {
      title: 'Top Rated News',
      desc: 'MTN Syria Is The Leading Provider In Telecommunications Services, Offering a Remarkable Cellular Network Access and Business Solutions'
    },
    investorCard: {
      title: 'Investor Relations',
      pdfFile: 'download pdf file'
    },
    TabsBar: {
      WhoWeAre: 'Who We Are',
      PressReleases: 'Press Releases',
      SocialResponsibility: 'Social Responsibility',
      InvestorRelations: 'Investor Relations',
      FinancialReports: 'Financial Reports'

    },
    FinancialReports: {
      title: 'Financial Reports',
      pdfTitle: 'Financial List For '
    },
    Support: {
      title: 'Support',
      FAQs: 'FAQs',
      Feedback: 'Feedback',
      ServicesCenters: 'Services Centers',
      contactUs: 'contact Us'
    },
    Bundles: {
      title: 'Bundles',
      sp: ' S.P',
      day: 'Day',
      month: 'Month',
      week: 'Week',
      min: ' Min',
      sms: ' SMS',
      activation: 'Activation Code',
      validation: 'Validation',
      validFor: 'Valid for ',
      renewed: ' and renewed automatically',
      dial: 'Dial the Code ',
      activate: ' to activate the bundle',
      details: 'Details'
    },
    offers: {
      title: 'Mtn Offers',
      special: 'Special Offers'
    },
    products: {
      title: 'Products',
      addInfo: {
        title: 'Additional Info',
        extraPre: 'More Information About Prepaid Line',
        extraPost: 'More Information About Postpaid Line',
        roamingText: 'More Information About Providers',
        btn: 'Show More'
      },
      table: {
        charging: 'Charging Unit',
        price: 'Price after fee',
        showBtn: 'Show Charging Units',
        hideBtn: 'Hide Charging Units',
        tableTitle: 'Prepaid Charging Units',
        service: 'From Service Center',
        dealers: 'From Dealers'
      },
      toolbar: {
        lines: {
          title: 'MTN Lines',
          header: 'MTN Mobile Lines',
          desc: 'The Postpaid Line Gives You The Opportunity To Talk Freely Without The Need To Repeatedly Recharge Your Balance Also You Can Subscribe To Tariff Bundles Designed Specially To Accommodate The Needs Of Customers.'
        },
        segment: 'Segmented Products',
        pre: 'Prepaid Lines',
        post: 'Postpaid Lines',
        payment: 'Payment and Refill',
        call: 'Call Management',
        international: 'International Calls Tariffs'
      }
    },
    serviceCenter: {
      findUs: 'Find Us',
      visit: 'Visit The nearest Service Center',
      search: 'Enter Governorate, then type area name',
      address: 'Address Details',
      workDays: 'Closed on',
      centerWorkHours: 'Center Work Hours',
      map: 'Show On Map',
      btn: 'Load More'
    },
    register: {
      title: 'Create New Account',
      desc: 'Enter your phone number to create your account',
      footer: 'Already Have An Account ?',
      footerLog: ' Login Here',
      verify: 'Verification Code',
      verifyDesc: 'Enter the code we sent to ',
      code: 'Did not get your code ?',
      resend: 'Resend Code'
    },
    login: {
      title: 'Login To Your Account',
      desc: 'Enter your number to login to your account',
      register: 'Do not have an account ?',
      registerBtn: 'Register Here'
    },
    addNum: {
      title: 'Add New Number',
      desc: 'Enter the number you want to add'
    },
    contactUs: {
      title: 'Contact Us',
      firstTitle: 'Thank You For Reaching Out.',
      secoundTitle: 'Please Reach Out To The Required Section',
      headOffice: 'Head Office',
      customerCare: 'Customer Care',
      salesAndDistribution: 'Sales And Distribution',
      mediaContact: 'Media Contact',
      salesSupport: 'Sales & Support',
      phone: 'Phone',
      fax: 'Fax',
      email: 'Email'
    },
    feedBack: {
      maintitle: 'Feedback',
      firstTitle: 'Thank You For Taking The Time To Visit Our Website.',
      secoundTitle: 'How Was Your Overall Experience',
      great: 'Great',
      good: 'Good',
      average: 'Average',
      poor: 'Poor',
      worst: 'Worst',
      maintitle2: 'Submit Your Message',
      firstTitle2: 'We Are Sorry To Hear That You Have Encountered A Problem And We Would Like To Assist You In Resolving It As Quickly As Possible.',
      form: {
        fullName: 'Full Name',
        mobileNumber: 'Mobile Number',
        email: 'Email',
        attachFile: 'Attach a file',
        issueDescription: 'Issue Description'
      },
      validation: {
        required: {
          fullName: 'Full Name is Required',
          mobileNumber: 'Mobile Number is Required',
          email: 'Email is Required',
          attachFile: 'File is Required',
          issueDescription: 'Issue Description is Required',
          Evaluation: 'Evaluation is Required !'
        },
        invalid: {
          fullName: 'Full Name not Valid',
          mobileNumber: 'Mobile Number not Valid',
          email: 'Email not Valid',
          attachFile: 'Attach a file not Valid',
          issueDescription: 'Issue Description not Valid'
        }
      },
      submit: 'Submit'
    },
    segmentedProducts: {
      sliderTitle: 'Segmented Products',
      sliderDesc: 'Special Needs Requires Special Offers, Wither You Are A Teacher , Student , Doctor , Soldier … We Got Your Back. Check For The Line That Suits You And Get All The Benefits From Our Offers And Bundles Which Are Made For You',
      mainTitle: 'Product & Services',
      secondaryTitle: 'Segmented Products'
    },
    submit: 'Submit',
    validation: 'Number is not valid',
    copyright: 'All rights reversed',
    internationalRoaming: {
      title: 'International Calls Roaming',
      description: 'Stay Connected And Access All Countries Of The World With International Roaming. Take Your Line Anywhere You Travel And Benefit From Mtn’s International Roaming Service. Make And Receive Your Calls, Messages And Data In All Countries Of The World.',
      secTitle: 'Calls Roaming for prepaid & postpaid lines',
      exploreButton: 'Explore Roaming Countries',
      cardTitle: 'More Information About International Roaming'
    },
    roamingService: {
      title: 'MTN SMS Roaming',
      description: 'SMS Roaming Offers Lines The Opportunity To Stay Connected By Sending Messages While Roaming In All Nations Of The World.',
      secTitle: 'SMS Roaming for prepaid & postpaid lines',
      exploreButton: 'Explore SMS Roaming Countries',
      international: 'International Roaming',
      SMS: 'SMS Roaming Service',
      cardTitle: 'More Information About Roaming Service'
    },
    paymentAndRefill: {
      title: 'Payment And Refill',
      boxTitle: 'About This Bundle',
      additionalInfoClose: 'More Information About This Service',
      additionalInfoOpen: 'The Most Common FAQS About This Bundle'
    },
    roamingCountries: {
      roaming: 'SMS Roaming',
      roamingInternational: 'International Calls Roaming',
      roamingCo: 'Roaming Countries',
      title: 'SMS Roaming Countries',
      secTitle: 'Operators list in :',
      description1: 'Please select the country to view the service availability',
      description2: 'Each Operator Have It\'s Own Services Please Check The Operator Service',
      showButton: 'Check Services',
      smallShowButton: 'Services',
      header1: 'Calling costs within the host country (local)',
      header2: 'Cost of calling an international number',
      header3: 'Cost of satellite communication',
      header4: 'Cost of calls to Syria ',
      smallHeader1: 'Calling costs within the host country (local)',
      smallHeader2: 'Cost of calling an international number',
      smallHeader3: 'Cost of satellite communication',
      smallHeader4: 'Cost of calls to Syria '
    },
    internationalCall: {
      title: 'From Syria To All Around The World!',
      servicePrices: 'Service Prices To:  ',
      table: {
        neighbor: 'Calling costs within the host country (local)',
        world: 'Cost of calling an international number',
        satellite: 'Cost of satellite communication',
        homeRate: 'Cost of calls to Syria ',
        neighborMobile: 'Calling costs within the host country (local)',
        worldMobile: 'Cost of calling an international number',
        satelliteMobile: 'Cost of satellite communication',
        homeRateMobile: 'Cost of calls to Syria '
      },
      line: {
        pre: 'Pre Paid',
        post: 'Post Paid'
      },
      msg: 'Service is not available in this country'
    },
    empty: 'No results found',
    profile: {
      active: 'Active',
      barInOut: 'Bar In/ Out',
      barOut: 'Bar Out',
      barIn: 'Bar In',
      greet: 'Welcome Back!',
      showProfile: 'Show Profile',
      userProfile: 'User Profile',
      editProfile: 'Edit Profile',
      payments: 'show Recent Payments',
      recentPayments: 'Recent Payments',
      export: 'Export As PDF',
      tabs: ['Active Bundles', 'Feature Controller', 'Services'],
      editProfileDialog: 'Edit User Profile',
      save: 'Save',
      personalInfo: {
        city: 'City :',
        gender: 'Gender :',
        job: 'Job :',
        email: 'Email :',
        birth: 'Birthdate :',
        address: 'Address :'
      },
      numbersData: {
        title: 'Numbers List',
        info: 'numbers added',
        activationDate: 'Activation Date',
        expiryDate: 'Expiry Date'
      },
      addBtn: 'Add New Item',
      addadslBtn: 'Add New ADSL number',
      startDate: 'Start Date : ',
      endDate: 'End Date : ',
      use: 'used',
      charTitles: 'Usage & Consumption',
      callForward: 'Call Forward'
    },
    digitalServices: {
      Title: 'Digital Services',
      mtnRadio: 'MTN Radio',
      download: 'Download ',
      charTitles: 'Usage & Consumption',
      editProfileDialog: 'Edit User Profile',
      save: 'Save',
      app: ' App'
    },
    reserveNumber: {
      mainTitle: 'Reserve A Number',
      title: 'Reserve A Number...',
      description: 'You can search & reserve a specific number from the available numbers list, (change the search parameter to get better results)',
      reserve: 'Reserve',
      search: 'Search',
      searchPlaceholder: 'Enter A Number Starts With..',
      showing: 'Showing Results For',
      numbers: 'numbers',
      start: 'Starts With',
      smallStart: 'Starts',
      end: 'End With',
      smallEnd: 'End',
      content: 'Contains',
      price: 'For Only',
      formTitle: 'Enter Your Presonal Data To Submit Your Action',
      Name: 'Name is Required',
      city: 'City is Required',
      NameValid: 'Name is Invalid',
      birth: 'Birthdate is Required',
      firstName: 'First Name',
      familyName: 'Family Name',
      father: 'Father',
      citeName: 'City',
      email: 'Email',
      anMobail: 'Another Mobile Number',
      birthdate: 'Birthdate',
      results: 'Results'
    },
    insure: 'Are you sure',
    delete: 'you want to delete this number ?',
    deactivate: 'you want to deactivate this item ?',
    deleteType: 'Delete',
    deactivateType: 'Deactivate',
    activateType: 'Activate',
    activate: 'you want to activate this item ?',
    actions: {
      ok: 'Ok',
      cancel: 'Cancel'
    },
    genders: {
      male: 'Male',
      female: 'Female'
    },
    logout: 'logout',
    ProfileValidation: {
      city: 'City is required',
      job: 'Job is required',
      address: 'Address is required',
      email: {
        required: 'Email is required',
        valid: 'Email not valid'
      },
      date: 'Birthdate is required',
      gender: 'Gender is required'
    },
    reservationFilter: {
      required: 'Number is required',
      valid: 'Number not valid'
    },
    feature: {
      busy: 'Busy',
      reach: 'Unreachable',
      answer: 'Unanswered',
      all: 'All of the above',
      enter: 'Enter the contact phone number',
      forward: '(Enter a number to forward your calls to while you are in another call)',
      superMessage: '(This action is related to the main service please select a status from the list below).',
      show: 'Show Service Data',
      deactivateNum: 'Deactivate a Number',
      activateNum: 'Activate a Number',
      hotLineNote: '(You can reactive the number again from the service below by submitting the line owner personal info)'
    },
    hotLine: {
      activate: 'Activate Hot line loss',
      enter: 'Enter the number and the National Id to activate it.',
      note: '(The number you are activating might not be in your numbers list)',
      deactivate: 'Deactivate Hot line loss',
      enter2: 'Enter the number and the National Id to deactivate it.',
      note2: '(The number you are deactivating might not be in your numbers list)',
      national: 'National ID Number',
      num: 'Phone Number',
      follow: 'Follow GSM',
      nationalReq: 'National ID is required',
      password: 'Password',
      passwordReq: 'Password is required'
    },
    super: {
      status: 'Service Status',
      reply: 'Auto Reply',
      callers: 'Callers List',
      general: 'General Message Repaly',
      generalNote: 'This message will appear to all your contacts when you the service is activated',
      generalPlace: 'Write your Message',
      exceptions: 'Exceptions',
      exceptionNote: 'Add special messages for the numbers you want, enter the number then add the message',
      addException: 'Add new Exception',
      myCallers: 'My Callers',
      callersNote: 'You can check your callers list at a cretan time, also you can search for your calls with a Specific number. ',
      select: 'Select (Day-Week-Month)',
      lastCallers: 'Last Week Callers List:',
      busy: '(The Service Will Be Activated When Your On Another Call)',
      unReach: '(The Service Will Be Activated When Your Unreachable)',
      all: '(The Service Will Be Activated In All Of The Above States)',
      addNum: 'Enter a phone number',
      callersList: 'Callers List'
    }
  },
  ar: {
    notFound: 'الصفحة غير موجودة',
    back: 'العودة للصفحة الرئيسية',
    free: 'مجاني',
    next: 'التالي',
    quick: 'الوصول السريع',
    checkAll: 'اكتشف جميع الباقات',
    reserve: 'احجز رقماً',
    prices: 'قائمة الأسعار',
    ourApps: 'تطبيقاتنا',
    apps: '',
    navbar: {
      sectionNavbar: [
        'الرئيسية',
        'المنتجات و الخدمات',
        'الباقات',
        'MTN عروض',
        'التجوال'
      ],
      baseNavbar: [
        'الصفحة الشخصية',
        'الأعمال',
        'الدفع الإلكتروني',
        // 'Mtn عروض',
        'Mtn عالم'
      ],
      serviceCenter: 'مراكز الخدمة',
      search: 'ابحث عن العرض أو الحزمة أو أكثر',
      smallSearch: 'البحث'
    },
    popularBundles: {
      title: 'الباقات الأكثر طلباً',
      desc: 'تحقق من كافة الباقات',
      showResults: 'عرض النتائج لـ : ',
      PrePaid: 'مسبق الدفع',
      PostPaid: 'لاحق الدفع'
    },
    dailyBundles: {
      title: 'الباقات اليومية',
      desc: 'اكتشف باقاتنا اليومية بما في ذلك المكالمات والرسائل القصيرة وباقات الإنترنت'
    },
    weeklyBundles: {
      title: 'الباقات الأسبوعية',
      desc: 'اكتشف باقاتنا الأسبوعية بما في ذلك المكالمات والرسائل النصية القصيرة وباقات الإنترنت'
    },
    monthlyBundles: {
      title: 'الباقات الشهرية',
      desc: 'اكتشف باقاتنا الشهرية بما في ذلك المكالمات والرسائل القصيرة وباقات الإنترنت'
    },
    offersDesc: 'اكتشف أحدث عروض الإنترنت والدقائق والرسائل التي يمكنك تفعيلها على جميع خطوط MTN الجديدة والقديمة والاستفادة منها شهرياً أو أسبوعياً أو يومياً ',
    mtnApps: {
      title: 'MTN تطبيقات',
      desc: 'ابق على اطلاع على كافة تطبيقات ' + 'MTN'
    },
    specialServices: {
      title: 'خدمات رقمية',
      desc: 'شاهد كافة خدمات ' + 'MTN'
    },
    featureController: {
      title: 'التحكم بالميزات',
      desc: 'اكتشف باقاتنا الخاصة للخطوط لاحقة الدفع متضمنة المكالمات،الرسائل القصيرة و باقات الإنترنت'
    },
    randomOffers: {
      title: 'عروض مخصصة لك',
      desc: ' شاهد كافة عروض MTN '
    },
    mtnApp: {
      title: '!ابق على اطلاع',
      desc: 'عرض ودفع الفواتير الخاصة بك وإعادة الشحن وتحويلات الرصيد ،الوصول الكامل والتحكم في جميع الأرقام المسجلة، الوصول إلى المكالمات والبيانات التفصيلية',
      git: 'Get the App for',
      download: 'Check the PWA for',
      downloadApp: 'iMTN حمل تطبيق'
    },
    offers: {
      title: 'MTN  عروض',
      special: 'عروض خاصة'
    },
    products: {
      title: 'المنتجات',
      addInfo: {
        title: 'معلومات إضافية',
        extraPre: 'معلومات إضافية عن الخطوط مسبقة الدفع',
        extraPost: 'معلومات إضافية عن الخطوط لاحقة الدفع',
        roamingText: 'معلومات إضافية عن المزودين',
        btn: ' المزيد'
      },
      table: {
        charging: 'وحدات التعبئة',
        price: 'السعر بعد الضريبة',
        showBtn: 'إظهار وحدات التعبئة',
        hideBtn: 'إخفاء وحدات التعبئة',
        tableTitle: 'وحدات تعبئة مسبقة الدفع',
        service: 'من مركز الخدمة',
        dealers: 'من الوسطاء'
      },
      toolbar: {
        lines: {
          title: 'MTN ' + 'خطوط ',
          header: 'الخليوية' + ' MTN خطوط',
          desc: 'الخلوية لاحقة و مسبقة الدفع' + ' MTN خطوط'
        },
        segment: 'المنتجات المخصصة',
        pre: 'خطوط مسبقة الدفع',
        post: 'خطوط لاحقة الدفع',
        payment: 'الدفع وإعادة التعبئة',
        call: 'إدارة الاتصالات',
        international: 'أسعار الاتصالات الدولية'
      }
    },
    footer: {
      aboutMTN: 'MTN حول',
      whoWeAre: 'من نحن',
      financialReport: 'التقارير المالية',
      pressCenter: 'مركز الصحافة',
      socialResponse: 'مسؤولية اجتماعية',
      investorRelations: 'علاقات المستثمرين',
      partners: 'الشركاء',
      mtnCareers: 'MTN وظائف',
      whyMtn: 'MTN لماذا',
      mtnJobs: 'MTN وظائف',
      emailHr: 'فريق الموارد البشرية',
      mtnBundles: 'MTN باقات',
      callsBundles: 'باقات الاتصال',
      dataBundles: 'باقات البيانات',
      smsBundles: 'باقات الرسائل',
      mixBundles: 'باقات ميكس',
      mtnApps: 'MTN تطبيقات',
      myMtn: 'MTN',
      mtnTv: 'MTN TV',
      mtnRadio: ' راديو ' + ' MTN ',
      mtnCash: ' كاش ' + ' MTN ',
      downloadMtn: 'iMTN حمل تطبيق',
      terms: 'الشروط و الأحكام، سياسة الخصوصية',
      copy: 'جميع الحقوق محفوظة',
      everyWhere: 'Every Where You Go'
    },
    readMore: 'اقرأ المزيد',
    needHelp: 'الدعم ؟',
    swipe: 'اسحب',
    supportMenu: {
      faq: 'الأسئلة الشائعة',
      serviceCenter: 'مراكز الخدمة',
      feedback: 'ملاحظات',
      contactUs: 'تواصل معنا'
    },
    welcomeMenu: {
      welcome: 'MTN أهلاً بكم في ',
      login: 'تسجيل دخول',
      register: 'إنشاء حساب',
      share: 'شارك عبر واتساب',
      newCustomer: 'زبون جديد',
      deals: 'سجل لتكشف عن صفقات حصرية'
    },
    shareDialog: {
      title: 'شارك هذه ',
      shareOffer: 'شارك هذا العرض',
      shareNews: 'شارك هذا الخبر',
      shareService: 'شارك هذه الخدمة',
      shareItem: 'شارك هذا العنصر',
      shareBundle: 'شارك هذه الباقة',
      shareVia: 'شارك عبر',
      bundle: 'رابط الباقة',
      offer: 'رابط العرض',
      service: 'رابط الخدمة',
      social: 'رابط العنصر',
      news: 'رابط الخبر',
      copy: 'نسخ'
    },
    whoWeAre: {
      MainTitle: 'حول MTN Syria',
      OurPartners: 'شركاؤنا',
      partnersDescription: 'الشراكة كانت دائماً أفضل طريقة للنجاح في مجالات مختلفة ، وستكون MTN سعيدة دائماً لتكون جزءاً من نجاحك',
      About: 'حول',
      companyName: 'اسم الشركة'
    },
    socialResponsibility: {
      title: 'مسؤولية اجتماعية',
      desc: 'هي المزود الرائد في خدمات الاتصالات ، حيث تقدم وصولاً رائعاً إلى الشبكة الخلوية وحلول الأعمال' + ' MTN Syria'
    },
    pressCenter: {
      title: 'الأخبار الأعلى تقييماً',
      desc: 'هي المزود الرائد في خدمات الاتصالات ، حيث تقدم وصولاً رائعاً إلى الشبكة الخلوية وحلول الأعمال' + ' MTN Syria'
    },
    investorCard: {
      title: 'علاقات المستثمرين',
      pdfFile: ' تحميل ملف pdf '
    },
    TabsBar: {
      WhoWeAre: 'من نحن',
      PressReleases: 'تصريحات صحفية',
      SocialResponsibility: 'مسؤولية اجتماعية',
      InvestorRelations: 'علاقات المستثمرين',
      FinancialReports: 'تقارير مالية'
    },
    FinancialReports: {
      title: 'تقارير مالية',
      pdfTitle: 'القائمة المالية للفترة '
    },
    Support: {
      title: 'الدعم',
      FAQs: 'أسئلة و أجوبة',
      Feedback: 'تعليقات',
      ServicesCenters: 'مراكز الخدمات',
      contactUs: 'تواصل معنا'
    },
    Bundles: {
      title: 'الباقات',
      sp: ' ل.س',
      day: 'يوم',
      month: 'شهر',
      week: 'أسبوع',
      min: ' دقيقة',
      sms: ' رسالة',
      activation: 'رمز التفعيل',
      validation: 'الصلاحية',
      validFor: 'صالح ل ',
      renewed: ' ويتم تجديدها تلقائياً',
      dial: ' اطلب الرمز ',
      activate: ' لتفعيل الباقة',
      details: 'التفاصيل'
    },
    serviceCenter: {
      findUs: 'اعثر علينا',
      visit: 'قم بزيارة أقرب مركز خدمة',
      search: 'أدخل المحافظة, ثم اكتب اسم المنطقة',
      address: 'تفاصيل العنوان',
      workDays: 'أيام العطل',
      centerWorkHours: 'ساعات عمل المركز',
      map: 'اظهار على الخريطة',
      btn: 'حمل المزيد'
    },
    register: {
      title: 'انشاء حساب جديد',
      desc: 'أدخل رقم هاتفك لانشاء حساب',
      footer: 'لديك حساب بالفعل ؟',
      footerLog: ' تسجيل دخول ',
      verify: 'رمز التأكيد',
      verifyDesc: 'أدخل الرمز الذي قمنا بإرساله الى الرقم',
      code: 'لم تحصل على الرمز ؟',
      resend: ' اعادة ارسال '
    },
    login: {
      title: 'سجل الدخول الى حسابك',
      desc: 'أدخل رقمك لتسجيل الدخول',
      register: 'ليس لديك حساب ؟ ',
      registerBtn: 'انشاء حساب'
    },
    addNum: {
      title: 'اضافة رقم جديد',
      desc: 'أدخل الرقم الذي تود اضافته'
    },
    contactUs: {
      title: 'اتصل بنا',
      firstTitle: 'شكراً لك على التواصل .',
      secoundTitle: 'يرجى التواصل مع القسم المطلوب',
      headOffice: 'المكتب الرئيسي',
      customerCare: 'رعاية العميل',
      salesAndDistribution: 'المبيعات و التوزيع',
      mediaContact: 'اتصال وسائل الإعلام',
      salesSupport: 'المبيعات و الدعم',
      phone: 'الهاتف',
      fax: 'الفاكس',
      email: 'البريد الإلكتروني'
    },
    feedBack: {
      maintitle: 'التعليقات والآراء',
      firstTitle: 'نشكرك على الوقت الذي قضيته في زيارة موقعنا',
      secoundTitle: 'كيف كانت تجربتك العامة',
      great: 'رائع',
      good: 'جيد',
      average: 'مقبول',
      poor: 'سيئ',
      worst: 'سيئ جداً',
      maintitle2: 'أرسل رسالتك',
      firstTitle2: 'نأسف لأنك واجهت مشكلة ونرغب في مساعدتك في حلها بأسرع ما يمكن',
      form: {
        fullName: 'الاسم الكامل',
        mobileNumber: 'رقم الهاتف',
        email: 'البريد الإلكتروني',
        attachFile: 'إرفاق ملف',
        issueDescription: 'وصف المشكلة'
      },
      validation: {
        required: {
          fullName: 'الاسم الكامل مطلوب',
          mobileNumber: 'رقم الهاتف مطلوب',
          email: 'البريد الإلكتروني مطلوب',
          attachFile: 'إرفاق ملف مطلوب',
          issueDescription: 'وصف المشكلة مطلوب',
          Evaluation: '! التقييم مطلوب'
        },
        invalid: {
          fullName: 'الاسم الكامل غير صالح',
          mobileNumber: 'رقم الهاتف غير صالح',
          email: 'البريد الإلكتروني غير صالح',
          attachFile: 'إرفاق ملف غير صالح',
          issueDescription: 'وصف المشكلة غير صالح'
        }
      },
      submit: 'إرسال'
    },
    segmentedProducts: {
      sliderTitle: 'المنتجات المخصصة',
      sliderDesc: 'تتطلب الاحتياجات الخاصة عروضاً خاصة، سواء كنت معلماً أو طالباً أو طبيباَ أو جندياً... نحن ندعمك. تحقق من العرض الذي يناسبك واستفد من جميع المزايا التي نقدمها من خلال عروضنا وحزمنا التي صُممت خصيصاَ لك',
      mainTitle: 'المنتجات & الخدمات',
      secondaryTitle: 'المنتجات المخصصة'
    },
    submit: 'تسجيل',
    validation: 'الرقم غير صالح',
    copyright: 'جميع الحقوق محفوظة',
    internationalRoaming: {
      title: 'تجوال المكالمات الدولية',
      description: 'ابقَ على اتصال واستمتع بالوصول إلى جميع بلدان العالم مع التجوال الدولي. خذ خطك معك أينما ذهبت واستفد من خدمة التجوال الدولي لشبكة MTN.  قم بإجراء واستقبال مكالماتك ورسائلك وبياناتك في جميع بلدان العالم.',
      secTitle: 'تجوال المكالمات  للخطوط مسبقة ولاحقة الدفع',
      exploreButton: 'اكتشف دول التجوال ' +
        '',
      cardTitle: 'مزيد من المعلومات حول التجوال الدولي'
    },
    roamingService: {
      title: 'خدمة تجوال الرسائل عبر MTN',
      description: 'توفر خدمة SMS Roaming للخطوط فرصة البقاء على اتصال من خلال إرسال الرسائل أثناء التجوال في جميع دول العالم.',
      secTitle: 'تجوال الرسائل النصية للخطوط مسبقة ولاحقة الدفع',
      exploreButton: 'اكتشف دول تجوال الرسائل النصية',
      international: 'التجوال الدولي',
      SMS: 'خدمة تجوال الرسائل النصية',
      cardTitle: 'مزيد من المعلومات حول خدمة التجوال'
    },
    paymentAndRefill: {
      title: 'الدفع و إعادة التعبئة',
      boxTitle: 'معلومات عن هذه الباقة',
      additionalInfoClose: 'مزيد من المعلومات حول الخدمة',
      additionalInfoOpen: 'الأسئلة الأكثر شيوعًا حول هذه الحزمة'
    },
    roamingCountries: {
      roaming: 'تجوال الرسائل القصيرة',
      roamingInternational: 'تجوال المكالمات الدولية',
      roamingCo: 'دول التجوال',
      title: 'دول تجوال الرسائل النصية',
      secTitle: 'قائمة المشغلين في :',
      description1: 'يرجى تحديد الدولة لعرض توفر الخدمة',
      description2: 'كل مشغل لديه خدماته الخاصة ، يرجى التحقق من خدمة المشغل',
      showButton: 'التحقق من الخدمات',
      smallShowButton: 'الخدمات',
      header1: 'كلفة الاتصال ضمن البلد المضيف',
      header2: 'كلفة الاتصال لرقم دولي',
      header3: 'كلفة الاتصال من خلال الأقمار الصناعية',
      header4: 'كلفة الاتصال الى سوريا',
      smallHeader1: 'كلفة الاتصال ضمن البلد المضيف',
      smallHeader2: 'كلفة الاتصال لرقم دولي',
      smallHeader3: 'كلفة الاتصال من خلال الأقمار الصناعية',
      smallHeader4: 'كلفة الاتصال الى سوريا'
    },
    internationalCall: {
      title: '!من سوريا إلى كل أنحاء العالم',
      servicePrices: '  سعر الخدمة في : ',
      table: {
        neighbor: 'الدول المجاورة للبلاد',
        world: 'باقي العالم',
        satellite: 'مشغلي الأقمار الصناعية والبحرية والطيران',
        neighborMobile: 'الدول المجاورة ',
        worldMobile: 'باقي العالم',
        satelliteMobile: 'الأقمار الصناعية والبحرية والطيران',
        homeRate: 'كلفة الاتصال الى سوريا'
      },
      line: {
        pre: 'مسبق الدفع',
        post: 'لاحق الدفع'
      },
      msg: 'الخدمة غير متاحة في هذه الدولة'
    },

    empty: 'لا توجد نتائج',
    profile: {
      active: 'فعٌال',
      barInOut: 'متوقف عن الاتصال الصادر والوارد',
      barOut: 'متوقف عن الاتصال الصادر',
      barIn: 'متوقف عن الاتصال الوارد',
      greet: 'مرحبا بعودتك',
      showProfile: 'استعراض ملف المستخدم',
      userProfile: 'ملف المستخدم',
      editProfile: 'تعديل الملف',
      payments: 'أحدث الدفعات',
      recentPayments: 'أحدث الدفعات',
      export: 'تصدير ك PDF',
      editProfileDialog: 'تعديل ملف المستخدم',
      save: 'حفظ',
      personalInfo: {
        city: 'المدينة :',
        gender: 'الجنس :',
        job: 'العمل :',
        email: 'البريد الالكتروني :',
        birth: 'تاريخ الميلاد :',
        address: 'العنوان :'
      },
      tabs: ['الباقات المفعلة', 'التحكم بالميزات', 'الخدمات'],
      numbersData: {
        title: 'قائمة الأرقام',
        info: 'أرقام مضافة',
        activationDate: 'تاريخ التفعيل',
        expiryDate: 'تاريخ الانتهاء'
      },
      addBtn: 'إضافة عنصر جديد',
      startDate: '  تاريخ البدء : ',
      endDate: '  تاريخ الانتهاء :',
      use: 'مستخدم',
      charTitles: 'الاستخدام & الاستهلاك',
      callForward: 'تحويل المكالمات'
    },
    digitalServices: {
      Title: 'الخدمات الرقمية',
      mtnRadio: 'راديو MTN',
      download: 'تحميل تطبيق ',
      app: 'تطبيق'
    },
    reserveNumber: {
      mainTitle: 'حجز رقم',
      title: 'حجز رقم...',
      description: 'يمكنك البحث وحجز رقم معين من قائمة الأرقام المتوفرة (قم بتغيير معامل البحث للحصول على نتائج أفضل)',
      reserve: 'حجز',
      search: 'بحث',
      searchPlaceholder: 'أدخل رقمًا يبدأ بـ..',
      showing: 'ظهور النتائج للأرقام',
      numbers: 'الأرقام',
      start: 'تبدأ بـ',
      smallStart: 'تبدأ',
      end: 'تنتهي بـ',
      smallEnd: 'تنتهي',
      content: 'تحتوي',
      price: 'فقط',
      formTitle: 'أدخل بياناتك الشخصية لإرسال الإجراء الخاص بك',
      Name: 'الاسم مطلوب',
      city: 'المدينة مطلوبة',
      birth: 'التاريخ مطلوب',
      NameValid: 'الاسم غير صحيح',
      firstName: 'الاسم الأول',
      familyName: 'الاسم الأخير',
      father: 'اسم الأب',
      citeName: 'المدينة',
      email: 'البريد الإلكتروني',
      anMobail: 'رقم هاتف آخر',
      birthdate: 'تاريخ الميلاد',
      results: 'نتائح'
    },
    insure: 'هل انت متأكد انك تريد',
    delete: 'حذف هذا الرقم',
    deactivate: 'الغاء تفعيل هذا العنصر ؟',
    activate: 'تفعيل هذا العنصر ؟',
    deleteType: 'حذف',
    deactivateType: 'الغاء تفعيل',
    activateType: 'تفعيل',
    actions: {
      ok: 'موافق',
      cancel: 'الغاء'
    },
    genders: {
      male: 'ذكر',
      female: 'انثى'
    },
    logout: 'تسجل الخروج',
    ProfileValidation: {
      city: 'المدينة مطلوبة',
      job: 'العمل مطلوب',
      address: 'العنوان مطلوب',
      email: {
        required: 'البريد الالكتروني مطلوب',
        valid: 'البريد الالكتروني غير صالح'
      },
      date: 'تاريخ الولادة مطلوب',
      gender: 'الجنس مطلوب'
    },
    reservationFilter: {
      required: 'الرقم مطلوب',
      valid: 'الرقم غير صالح'
    },
    feature: {
      busy: 'مشغول',
      reach: 'غير متاح',
      answer: 'لم يتم الرد على الاتصال',
      all: 'كل ما سبق',
      enter: ' أدخل رقم الهاتف للاتصال',
      forward: '(أدخل رقماً لتحويل مكالماتك إليه أثناء اتصال آخر)',
      superMessage: '(يتعلق هذا الإجراء بالخدمة الرئيسية، يرجى تحديد الحالة من القائمة أدناه).',
      show: 'عرض معلومات الخدمة',
      deactivateNum: 'إلغاء تفعيل رقم',
      activateNum: 'تفعيل رقم',
      hotLineNote: '(يمكنك إعادة تفعيل الرقم مرة أخرى من الخدمة أدناه عن طريق إدخال المعلومات الشخصية لصاحب الخط)'
    },
    hotLine: {
      activate: 'تفعيل إيقاف الخط بسبب الضياع',
      enter: 'أدخل الرقم والرقم الوطني للهوية لتفعيله.',
      note: '(الرقم الذي تقوم بتفعيله قد لا يكون في قائمة أرقامك)',
      deactivate: 'إلغاء تفعيل إيقاف الخط بسبب الضياع',
      enter2: 'أدخل الرقم والرقم الوطني للهوية لإلغاء تفعيله.',
      note2: '(الرقم الذي تقوم بإلغاء بتفعيله قد لا يكون في قائمة أرقامك)',
      national: 'الرقم الوطني للهوية',
      num: 'رقم الهاتف',
      follow: 'رقم المتابعة',
      nationalReq: 'الرقم الوطني مطلوب',
      password: 'كلمة المرور',
      passwordReq: 'كلمة المرور مطلوبة'
    },
    super: {
      status: 'حالة الخدمة',
      reply: 'الرد التلقائي',
      callers: 'قائمة المتصلين',
      general: 'الرسالة العامة للرد',
      generalNote: 'هذه الرسالة ستظهر لجميع جهات الاتصال الخاصة بك عند تفعيل الخدمة',
      generalPlace: 'اكتب رسالتك',
      exceptions: 'استثناءات',
      exceptionNote: 'أضف رسائل خاصة للأرقام التي ترغب فيها، أدخل الرقم ثم أضف الرسالة',
      addException: 'إضافة استثناء جديد',
      myCallers: 'المتصلين بي',
      callersNote: 'يمكنك التحقق من قائمة المتصلين في وقت محدد، كما يمكنك البحث عن مكالماتك باستخدام رقم محدد.',
      select: 'اختر (يوم-أسبوع-شهر)',
      lastCallers: 'قائمة متصلي الأسبوع الماضي:',
      busy: 'سيتم تفعيل الخدمة عندما يكون لديك مكالمة أخرى',
      unReach: '(سيتم تفعيل الخدمة عندما تكون غير متاح)',
      all: '(سيتم تفعيل الخدمة في جميع الحالات المذكورة أعلاه)',
      addNum: 'أدخل رقم هاتف',
      callersList: 'قائمة المتصلين'
    }
  }
}
